import { useCallback, useState } from 'react';
import { Box, ButtonBase, Dialog, InputBase, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { CloseIcon, MinusIcon, PlusIcon } from '../../../../../components/Icon';
import LongRemark from '../../../../../components/LongRemark';
import { WarpSwitch } from '../../../../../components/WarpSwitch';
import { classNames } from '../../../../../utils';
import DiaLog from '../../../../../components/Dialog';
import { i18n } from '../../../../../language';
const useStyles = makeStyles(() => ({
  root: {
    '& .MuiDialog-paperWidthSm': {
      maxWidth: 'none',
    },
    '& .MuiPaper-root': {
      backgroundColor: '#FFFFFF',
      borderRadius: '15px !important',
      boxShadow: '0 -0.125rem 1.3125rem rgba(30, 56, 140, 0.18)',
      margin: '0',
      padding: '2.722rem 1.875rem 0',
      width: '44.375rem',
    },
  },
  title: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    color: '#2e4469',
  },
  subTitle: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.25rem',
    color: '#2e4469',
  },
  content: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
    marginTop: '0.313rem',
  },
  closeBtn: {
    width: '1.945rem',
    height: '1.945rem',
    color: '#538fff',
    '&.MuiButtonBase-root.Mui-disabled': {
      color: '#e4e7eb',
    },
  },
  closeIcon: {
    fontSize: '1.5rem',
  },
  registerBtn: {
    textAlign: 'center',
    borderRadius: '8px',
    backgroundColor: '#538fff',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#fff',
    width: '7.25rem',
    height: '3rem',
    '&.MuiButtonBase-root.Mui-disabled': {
      backgroundColor: '#e4e7eb',
      color: '#2e4469',
    },
  },
  input: {
    width: '100%',
    height: '3.5rem',
    borderRadius: '10px',
    border: 'solid 1px #e4e7eb',
    paddingLeft: '1.25rem',
    paddingRight: '1.188rem',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
  inputTitle: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#666666',
    marginBottom: '0.938rem',
  },
  settingText: {
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  contentText: {
    fontSize: '0.875rem',
    color: '#7d86a9',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginLeft: '0.625rem',
  },
  icon: {
    color: '#538fff',
  },
  inputNum: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.25rem',
    color: '#3e3e3e',
    borderLeft: '1px solid #e4e7eb',
    borderRight: '1px solid #e4e7eb',
    '&>input': {
      textAlign: 'center',
    },
  },
  buttonBtn: {
    width: '3.5rem',
    height: '3.5rem',
    padding: '1.688rem 1.25rem',
    '&.Mui-disabled': {
      backgroundColor: '#e4e7eb',
      borderTopLeftRadius: '10px',
      borderBottomLeftRadius: '10px',
      color: '#939393',
    },
  },
  buttonAddBtn: {
    width: '3.5rem',
    height: '3.5rem',
    padding: '1.688rem 1.25rem',
    '&.Mui-disabled': {
      backgroundColor: '#e4e7eb',
      borderTopRightRadius: '10px',
      borderBottomRightRadius: '10px',
      color: '#939393',
    },
  },
  symbol: {
    fontSize: '1.25rem',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    color: '#2e4469',
    marginTop: '1.8rem',
  },
  iconDisabled: {
    color: '#939393',
  },
  confirmContent: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    color: '#2e4469',
  },
}));

const Counter = ({ onChange, value, minNum = 1, maxNum = 30, ctrl = true }) => {
  const classes = useStyles();
  const reduceHandler = useCallback(() => {
    if (!ctrl) {
      return;
    }

    onChange(value - 1);
  }, [value, onChange, ctrl]);
  const changeHandler = useCallback(
    (event) => {
      if (event.target.value < 1) {
        onChange(1);
      } else if (event.target.value < minNum) {
        onChange(minNum);
      } else if (event.target.value > maxNum) {
        onChange(maxNum);
      } else {
        onChange(Number(event.target.value));
      }
    },
    [onChange]
  );
  const addHandler = useCallback(() => {
    if (!ctrl) {
      return;
    }
    if (value !== 30) {
      onChange(value + 1);
    } else {
      return;
    }
  }, [value, onChange, ctrl]);
  return (
    <Box
      display="flex"
      border="solid 1px #e4e7eb"
      borderRadius="10px"
      p="0"
      height="3.5rem"
      bgcolor={ctrl ? '#fff' : '#f5f5f5'}
      justifyContent="space-between"
    >
      <ButtonBase
        id="qty-reduce"
        onClick={reduceHandler}
        className={classes.buttonBtn}
        disabled={ctrl && value === minNum}
      >
        <MinusIcon className={classNames(classes.icon, ctrl && value === minNum && classes.iconDisabled)} />
      </ButtonBase>

      <InputBase
        id="qty-input"
        className={classes.inputNum}
        inputProps={{ type: 'number' }}
        onChange={changeHandler}
        value={value}
        readOnly={!ctrl}
      />

      <ButtonBase
        id="qty-add"
        onClick={addHandler}
        className={classes.buttonAddBtn}
        disabled={ctrl && value === maxNum}
      >
        <PlusIcon className={classNames(classes.icon, ctrl && value === maxNum && classes.iconDisabled)} />
      </ButtonBase>
    </Box>
  );
};
const ServiceHoursSetting = ({ onClose, saveSetting, settingData }) => {
  const classes = useStyles();
  const loginInfo = useSelector((state) => state.loginInfo);
  const [formData, setFormData] = useState({
    bookCheckExist: settingData?.bookCheckExist ? settingData?.bookCheckExist : false,
    numOfDaysRelease: settingData?.numOfDaysRelease ? settingData?.numOfDaysRelease : 3,
    weeklyQuota: settingData?.weeklyQuota ? settingData?.weeklyQuota : 2,
    dailyQuota: settingData?.dailyQuota ? settingData?.dailyQuota : 1,
    hospitalId: loginInfo.hospitalId,
    wardId: loginInfo.wardId,
  });
  const [popupOpen, setPopupOpen] = useState(false);

  const formHandler = useCallback((key) => {
    return (value) => {
      if (value <= 30) {
        setFormData((preData) => ({ ...preData, [key]: value }));
      }
    };
  }, []);

  const saveHandler = useCallback(() => {
    if (!popupOpen && settingData?.numOfDaysRelease > formData.numOfDaysRelease) {
      setPopupOpen(true);
    } else if (typeof saveSetting === 'function') {
      saveSetting({ ...formData, hospitalId: loginInfo.hospitalId, wardId: loginInfo.wardId }, onClose);
    }
  }, [formData, settingData?.numOfDaysRelease, popupOpen, saveSetting]);

  const switchHandleChange = (type) => {
    return (event) => {
      setFormData((preData) => ({ ...preData, [type]: event.target.checked }));
    };
  };

  return (
    <>
      <Dialog className={classes.root} open={true}>
        {/* header */}
        <Box display="flex" justifyContent="space-between" mb="1.965rem">
          <div className={classes.title}>{i18n.t('TELEVISIT_SETTING_POPUP_SETTING')}</div>
          <ButtonBase className={classes.closeBtn} onClick={onClose}>
            <CloseIcon className={classes.closeIcon} />
          </ButtonBase>
        </Box>
        {/* body */}
        <Box display="flex" flexDirection="column" gridRowGap="1.875rem">
          <div className={classes.settingText}>{i18n.t('TELEVISIT_SETTING_POPUP_SETTING_DESC')}</div>
          <Box display="flex" flexDirection="column" gridRowGap="0.938rem">
            <Box className={classes.subTitle} display="flex" alignItems="center">
              {i18n.t('TELEVISIT_SETTING_POPUP_BOOKING_DAY')}
              <LongRemark
                content={
                  <div dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_SETTING_POPUP_BOOKING_DAY_REMARK') }} />
                }
                width="100%"
                minWidth="10rem"
                id="serviceDay"
              />
            </Box>
            <Box display="flex" justifyContent="space-between" gridColumnGap="1.25rem">
              <Box display="flex" flexDirection="column" flexBasis="50%" maxWidth="18.5rem">
                <div className={classes.inputTitle}>{i18n.t('TELEVISIT_SETTING_POPUP_BOOKING_DAY_DESC')}</div>
                <Counter
                  value={formData.numOfDaysRelease ? formData.numOfDaysRelease : 3}
                  onChange={formHandler('numOfDaysRelease')}
                  minNum={1}
                />
              </Box>
            </Box>
          </Box>
          <Box display="flex" flexDirection="column" gridRowGap="0.938rem">
            <Box className={classes.subTitle} display="flex" alignItems="center">
              {i18n.t('TELEVISIT_SETTING_POPUP_QUOTA')}
              <LongRemark
                content={i18n.t('TELEVISIT_SETTING_POPUP_QUOTA_REMARK')}
                width="100%"
                minWidth="10rem"
                id="patientQuota"
              />
            </Box>
            <Box display="flex" justifyContent="space-between" gridColumnGap="1.25rem">
              <Box display="flex" flexDirection="column" flexBasis="50%" maxWidth="18.5rem">
                <div className={classes.inputTitle}>{i18n.t('TELEVISIT_SETTING_POPUP_QUOTA_WEEKLY')}</div>
                <Counter
                  value={formData.weeklyQuota ? formData.weeklyQuota : 2}
                  onChange={formHandler('weeklyQuota')}
                  minNum={formData.dailyQuota ?? 1}
                />
              </Box>
              <Box display="flex" alignItems="center">
                <div className={classes.symbol}>&</div>
              </Box>
              <Box display="flex" flexDirection="column" flexBasis="50%" maxWidth="18.5rem">
                <div className={classes.inputTitle}>{i18n.t('TELEVISIT_SETTING_POPUP_QUOTA_DAILY')}</div>
                <Counter
                  value={formData.dailyQuota ? formData.dailyQuota : 1}
                  onChange={formHandler('dailyQuota')}
                  maxNum={formData.weeklyQuota ?? 30}
                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box display="flex" mt="1.25rem" alignItems="center">
          <WarpSwitch checked={formData.bookCheckExist} onChange={switchHandleChange('bookCheckExist')} />
          <div className={classes.contentText}>{i18n.t('TELEVISIT_SETTING_POPUP_QUOTA_DESC')}</div>
        </Box>

        {/* footer */}
        <Box display="flex" justifyContent="center" alignItems="center" p="2rem" mt="0.5rem">
          <ButtonBase className={classes.registerBtn} onClick={saveHandler}>
            {i18n.t('TELEVISIT_SETTING_POPUP_SAVE')}
          </ButtonBase>
        </Box>
      </Dialog>
      <UpdateBookingDaysPopup open={popupOpen} handleClose={() => setPopupOpen(false)} handleSubmit={saveHandler} />
    </>
  );
};

const UpdateBookingDaysPopup = ({ handleSubmit, handleClose, open }) => {
  const classes = useStyles();
  return (
    <DiaLog
      open={open}
      title={i18n.t('TELEVISIT_SETTING_POPUP_UPDATE_BOOKING_CONFIRM_TITLE')}
      cancel={i18n.t('SETTING_CANCEL')}
      confirm={i18n.t('SETTING_CONFIRM')}
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleSubmit}
    >
      <div
        className={classes.confirmContent}
        dangerouslySetInnerHTML={{ __html: i18n.t('TELEVISIT_SETTING_POPUP_UPDATE_BOOKING_CONFIRM_CONTENT') }}
      />
    </DiaLog>
  );
};

export default ServiceHoursSetting;
